import React from 'react';
import { Button, Image } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
// import stgLogo from '../assets/images/stg-epay-logo.png';
import stgLogo from '../assets/images/epayLogo.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/fontawesome-free-solid';
import { useNavigate } from 'react-router-dom';

export default function Header(props) {
  let navigate = useNavigate();
  const goHome = () => {
    navigate("/");
  }
  return (
    <>
      <Navbar expand="lg" className="bg-body-tertiary bg-header">
        <Container className='border-bottom1 p-0'>
          <Navbar.Brand href="/">
            <Image src={stgLogo} height={85} width={230} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              {/* <Nav.Link href="/" className='btn btn-sm btn-primary text-white p-0'> <FontAwesomeIcon icon={faHome} /> Home</Nav.Link> */}
              <Button onClick={goHome} className='btn-sm mx-3'><FontAwesomeIcon icon={faHome} /> Home</Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  )
}
